import React, { useEffect, useState } from 'react';
import { PauseIcon, PlayIcon } from 'lucide-react';
interface AudioMasterProps {
  label: string;
  driveUrl: string;
}
const TOTAL = 1724;
function toClock(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const rest = Math.floor(seconds % 60);
  return `${String(minutes).padStart(2, '0')}:${String(rest).padStart(2, '0')}`;
}
export function AudioMaster({
  label,
  driveUrl
}: AudioMasterProps) {
  const [playing, setPlaying] = useState(false);
  const [position, setPosition] = useState(0);
  useEffect(() => {
    if (!playing) return;
    const timer = window.setInterval(() => {
      setPosition(current => current >= TOTAL ? 0 : current + 1);
    }, 90);
    return () => window.clearInterval(timer);
  }, [playing]);
  return <div className="flex items-center gap-5 border-t border-rule py-6 sm:gap-8" data-id="element-22" data-mp="174ep6ds0uewj">
      <button type="button" onClick={() => setPlaying(current => !current)} aria-label={playing ? `Pause ${label}` : `Play ${label}`} className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-ink text-ink transition-colors duration-150 ease-out hover:bg-ink hover:text-paper" data-id="element-23" data-mp="176j4drvdf0c4">
        {playing ? <PauseIcon className="h-4 w-4" strokeWidth={1} data-id="element-24" data-mp="1xmo61k7xok5x" /> : <PlayIcon className="h-4 w-4 translate-x-[1px]" strokeWidth={1} data-id="element-25" data-mp="22l8y2wd17xja" />}
      </button>
      <div className="min-w-0 flex-1" data-id="element-26" data-mp="1olgah9wsxxfj">
        <p className="font-display text-lg leading-none" data-id="element-27" data-mp="1oom2awwtfdey">{label}</p>
        <div className="mt-4 h-px w-full bg-rule" data-id="element-28" data-mp="1sow6q54ylvrp">
          <div className="h-px bg-ink transition-[width] duration-150 ease-linear" style={{
          width: `${position / TOTAL * 100}%`
        }} data-id="element-29" data-mp="1eoboba2yi1yq" />
        </div>
      </div>
      <div className="shrink-0 text-right" data-id="element-30" data-mp="392cw4kghhzay">
        <p className="font-sans text-xs tracking-wide2 text-graphite" data-id="element-31" data-mp="393e8qtd5etus">
          {toClock(position)} / {toClock(TOTAL)}
        </p>
        <p className="label-sm mt-2 text-mute" data-id="element-32" data-mp="3e0o38nfe9vph">
          {driveUrl ? 'Drive source linked' : 'Awaiting Drive link'}
        </p>
      </div>
    </div>;
}